import React from 'react';
import { useNavigate } from 'react-router-dom';

import { SvgCardType } from '../../components/svg-card/svg-card-types';
import { urler } from '../../router/router-urler';
import { RadioAlternativ } from '../../sporsmalsflyt/reducer/sporsmalsflyt-types';
import { Skademeldingstype } from '../../types/generated-types';
import { skadeUrlFromSkadetype } from '../../urler';
import { GruppeLandingsside } from '../gruppe-landingsside';
import { KategoriSvarId } from '../sporsmal-og-svar';

const alternativer: RadioAlternativ[] = [
    {
        id: KategoriSvarId.RettshjelpTvistKjopSalgBolig,
        tekst: 'Tvist knyttet til kjøp/salg av leilighet, bolig eller fritidseiendom',
    },
    {
        id: KategoriSvarId.RettshjelpTvistKjoretoy,
        tekst: 'Tvist knyttet til kjøretøy',
    },
    {
        id: KategoriSvarId.RettshjelpTvistEntreprenorEllerHandverker,
        tekst: 'Tvist mot entreprenør eller håndverker',
    },
    {
        id: KategoriSvarId.RettshjelpTvistNabo,
        tekst: 'Tvist mot nabo',
    },
    {
        id: KategoriSvarId.RettshjelpTvistJordskifteEllerFesterett,
        tekst: 'Tvist om jordskifte- eller festerett',
    },
    {
        id: KategoriSvarId.RettshjelpTvistOffentligForvaltningsvedtak,
        tekst: 'Tvist om offentlig forvaltningsvedtak',
    },
    {
        id: KategoriSvarId.RettshjelpTvistAnnet,
        tekst: 'Annen type tvist',
    },
];

export const RettshjelpPrivat = () => {
    const navigate = useNavigate();

    const onNext = (svarId: string) => {
        if (svarId === KategoriSvarId.RettshjelpTvistKjopSalgBolig) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.RettshjelpTvistBolig));
        } else if (svarId === KategoriSvarId.RettshjelpTvistKjoretoy) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.RettshjelpTvistKjoretoy));
        } else if (svarId === KategoriSvarId.RettshjelpTvistEntreprenorEllerHandverker) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.RettshjelpTvistEntreprenorEllerHandverker));
        } else if (svarId === KategoriSvarId.RettshjelpTvistNabo) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.RettshjelpTvistNabo));
        } else if (svarId === KategoriSvarId.RettshjelpTvistJordskifteEllerFesterett) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.RettshjelpTvistJordskifteEllerFesterett));
        } else if (svarId === KategoriSvarId.RettshjelpTvistOffentligForvaltningsvedtak) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.RettshjelpTvistOffentligForvaltningsvedtak));
        } else if (svarId === KategoriSvarId.RettshjelpTvistAnnet) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.RettshjelpTvistAnnenType));
        }
    };

    return (
        <GruppeLandingsside
            title="Rettshjelp"
            onNext={onNext}
            navigateToParent={() => navigate(urler().rettshjelpUrl)}
            alternativer={alternativer}
            svgCardType={SvgCardType.Samtykke}
            radioButtonsLabel="Hva slags tvist har oppstått?"
            kategoriId="rettshjelp-privat"
        />
    );
};
